// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__spQHi","actions":"GroupTable_actions__2-Bk4","deleteModalFooter":"GroupTable_deleteModalFooter__XwQGd"};